<template>
  <BedplaceInfoGallery
    :images="infoCarouselImages"
    :facilities="hotel.highlighted_facilities"
    :location="hotelLocation"
    :initial-slide="initialSlide"
    only-render-visible-slides
    prevent-swiper-update
  />
</template>

<script>
import { mapState } from 'pinia'
import hotelImagesMixin, { supplierURLs } from '@packages/media/mixins/hotel-images.mixin'

export default defineNuxtComponent({
  setup () {
    const { urls: localeURLs } = useLocale()

    return {
      localeURLs,
    }
  },

  mixins: [hotelImagesMixin],

  props: {
    hotel: {
      type: Object,
      required: true,
    },

    showLinkToHotel: {
      type: Boolean,
      default: false,
    },

    initialSlide: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapState(useLocaleStore, [
      'localeURLs',
    ]),

    infoCarouselImages () {
      try {
        if (this.hotel?.image && !this.hotel?.meta.images && !this.hotel?.images) {
          return [this.hotel.image]
        }

        const images = (this.hotel?.images || this.hotel?.meta.images || []).slice(0, 11)
        return images
          .filter(Boolean)
          .map(i => this.createImageObject(
            i?.image,
            i?.image_type ||
            this.hotel.meta.images_type ||
            this.hotel.supplier
          ))
      } catch (e) {
        this.$sentryCaptureException(e)
        return []
      }
    },

    hotelLocation () {
      return {
        destination: this.hotel.townName || this.hotel.zone_name || this.hotel.address?.city,
        postcode: this.hotel.address?.postal_code ?? this.hotel.meta?.PostcodeZip,
        locality: this.hotel.address?.city || this.hotel.zone_name,
        country: this.hotel.country,
      }
    },
  },

  methods: {
    createImageObject (image, type) {
      const baseUrl = supplierURLs[type]?.replace('[PATH]', image)

      return {
        src: this.imageSize(baseUrl, this.autoImageSize()),
        type,
        path: baseUrl,
        image,
      }
    },
  },
})
</script>
